import { render } from "./answers.vue?vue&type=template&id=7f4eaeda"
import script from "./answers.vue?vue&type=script&lang=js"
export * from "./answers.vue?vue&type=script&lang=js"

import exportComponent from "/home/sophia/sophia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__